module Easypass {
    class RouteServiceProvider extends Core.RouteServiceProvider {
        footers = {
            services: <ng.ui.IState>{
                templateUrl: './servicesFooter.html'
            }
        }
    }
    angular.module('easypass').provider('routeService', ['$stateProvider', RouteServiceProvider]);
}